import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PrintButton from './Button';
import { createRoot } from 'react-dom/client';
import AppProvider from '@components/Shared/State/provider';
import SbThemeProvider from '@components/theme/provider';
import useProductPage from '@themes/product/useProductPage';
const LoadPrintProductComponent = () => {
    const [{ product }] = useProductPage(0, 0, [], null, false, false);
    return product && _jsx(PrintButton, {});
};
export default function LoadPrint(element) {
    const rootDom = createRoot(element);
    rootDom.render(_jsx(AppProvider, { children: _jsx(SbThemeProvider, { children: _jsx(LoadPrintProductComponent, {}) }) }));
}
